import { Instagram, Youtube } from "lucide-react";

export const SOCIALS = [
  { key: "instagram", label: "Instagram", href: "https://www.instagram.com/rmctech101", Icon: Instagram },
  { key: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@rmctechsolodev", Icon: TikTokIcon },
  { key: "youtube", label: "YouTube", href: "https://www.youtube.com/@rmctech101", Icon: Youtube },
];

function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .59.05.87.13V9.4a6.33 6.33 0 0 0-1-.05A6.34 6.34 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
    </svg>
  );
}

// Reusable row of social links. `variant`: "dark" (light icons on dark bg) or "light".
export default function SocialLinks({ variant = "dark", className = "" }) {
  const base =
    variant === "dark"
      ? "text-zinc-400 hover:text-brand-yellow"
      : "text-gray-500 hover:text-brand-orange";
  return (
    <div className={`flex items-center justify-center gap-5 ${className}`} data-testid="social-links">
      {SOCIALS.map(({ key, label, href, Icon }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          data-testid={`social-${key}`}
          className={`transition-colors ${base}`}
        >
          <Icon className="h-6 w-6" />
        </a>
      ))}
    </div>
  );
}
